export type Properties = Record<string, unknown>

export enum ExportType {
  CSV = 'csv',
  EXCEL = 'excel'
  // PDF = 'pdf'
}
